import { render, staticRenderFns } from "./ReservationLandingPageBuilder.vue?vue&type=template&id=0bb75b95&scoped=true"
import script from "./ReservationLandingPageBuilder.vue?vue&type=script&lang=js"
export * from "./ReservationLandingPageBuilder.vue?vue&type=script&lang=js"
import style0 from "./ReservationLandingPageBuilder.vue?vue&type=style&index=0&id=0bb75b95&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb75b95",
  null
  
)

export default component.exports